import { defineComponent } from 'vue';
/**
 * SocketListener
 * vue component that can be used in templates
 * and have @someEvent things attached to it
 */
export const SocketListener = defineComponent({
    mounted() {
        if (this.$socket) {
            this.$socket.addEventListener('message', this.onMessage);
        }
        else {
            console.warn('[SocketListener] SocketPlugin not detected');
        }
    },
    unmounted() {
        if (this.$socket) {
            this.$socket.removeEventListener('message', this.onMessage);
        }
        else {
            console.warn('[SocketListener] SocketPlugin not detected');
        }
    },
    methods: {
        onMessage(e) {
            const { event, props } = e.detail;
            this.$emit(event, props);
        }
    },
    render() { return false; }
});
